import { faUsers } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Badge, Button, Table, Container } from "react-bootstrap";
import { FaEdit, FaTrash } from "react-icons/fa";
import classes from "./CustomersTable.module.css";
import {
    formatarData,
    formatarDocumentoAuto,
    formatarTelefone,
    totalBeneficiarios,
} from "./customersUtils";

export default function CustomersTable({ customers, onEdit, onDelete }) {

    return (
        <Container fluid className="mt-4 mb-5">
            <div className="table-responsive">
                <Table bordered className={classes.customTable}>
                    <thead className="table-dark">
                        <tr>
                            <th>ID</th>
                            <th>Customer</th>
                            <th>Tipo</th>
                            <th>CPF / CNPJ</th>
                            <th>Contato</th>
                            <th>Cidade / UF</th>
                            <th className="text-center">
                                <FontAwesomeIcon icon={faUsers} /> Beneficiários
                            </th>
                            <th>Status</th>
                            <th>Criado em</th>
                            <th className="text-center">Ações</th>
                        </tr>
                    </thead>

                    <tbody>
                        {customers.length === 0 && (
                            <tr>
                                <td colSpan={10} className={classes.vazio}>
                                    Nenhum customer encontrado.
                                </td>
                            </tr>
                        )}

                        {customers.map((c, index) => {

                            const inativo = c.ativo === false;
                            const total = c.beneficiarios;

                            const rowStyle = [
                                index % 2 === 0 ? classes.rowEven : classes.rowOdd,
                                inativo ? classes.inativo : "",
                            ].join(" ");

                            return (
                                <tr key={c.id} className={rowStyle}>

                                    <td>{c.id}</td>

                                    <td className="fw-semibold">{c.nome_razao_social}</td>

                                    <td>
                                        <Badge bg={c.tipo_pessoa === "J" ? "primary" : "info"}>
                                            {c.tipo_pessoa === "J" ? "PJ" : "PF"}
                                        </Badge>
                                    </td>

                                    <td className={classes.mono}>
                                        {formatarDocumentoAuto(c.cpf_cnpj)}
                                    </td>

                                    <td className={classes.contato}>
                                        {c.email}
                                        <small>{formatarTelefone(c.telefone_principal)}</small>
                                    </td>

                                    <td className="text-nowrap">
                                        {[c.cidade, c.estado].filter(Boolean).join(" / ")}
                                    </td>

                                    <td className="text-center">
                                        <Badge
                                            pill
                                            bg={total > 0 ? "primary" : "secondary"}
                                            title={
                                                total === 0
                                                    ? "Nenhum beneficiário"
                                                    : `${total} beneficiário(s)`
                                            }
                                        >
                                            {total}
                                        </Badge>
                                    </td>

                                    <td>
                                        <Badge bg={inativo ? "secondary" : "success"}>
                                            {inativo ? "Inativo" : "Ativo"}
                                        </Badge>
                                    </td>

                                    <td className="text-nowrap">
                                        {formatarData(c.data_criacao, true)}
                                    </td>

                                    <td>
                                        <div className="d-flex justify-content-center">

                                            <Button
                                                size="sm"
                                                variant="outline-primary"
                                                className="me-1"
                                                title="Editar"
                                                onClick={() => onEdit(c)}
                                            >
                                                <FaEdit />
                                            </Button>

                                            <Button
                                                size="sm"
                                                variant="outline-danger"
                                                title="Inativar"
                                                disabled={inativo}
                                                onClick={() => onDelete(c)}
                                            >
                                                <FaTrash />
                                            </Button>

                                        </div>
                                    </td>

                                </tr>
                            );
                        })}
                    </tbody>
                </Table>
            </div>
        </Container>
    );
}
